import React from "react";
import { PlaySVG } from "../../../assets/svgs";
import ReactHtmlParser from "react-html-parser";
export default function VideoItem({ setter, index, video, btnClass, items }) {
  return (
    <div className={`${btnClass} playlist`} key={index}>
      <PlaySVG width="20px" height="20px" />
      <p
        style={{
          minWidth: "80%",
          textAlign: "start",
          display: "flex",
          alignContent: "end",
          justifyContent: "space-between",
          fontSize: "15px",
        }}
        className="test"
      >
        {ReactHtmlParser(video.title)}
      </p>
      <button
        onClick={() => setter(index, items)}
        type="button"
        className="play-btn"
      >
        Play
      </button>
    </div>
  );
}
